import React from "react";
import { Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "./ProtectedRoute";

import SignIn from "./Pages/SignIn";
import Dashboard from "./Pages/Dashboard";
import TwoStep from "./Pages/TwoStep";
import Country from "./Pages/Locations/Country";
import State from "./Pages/Locations/State";
import City from "./Pages/Locations/City";
import Building from "./Pages/Locations/Building";
import Floor from "./Pages/Locations/Floor";
import Screen from "./Pages/Locations/Screen";
import Add from "./Pages/Users/Add";
import Users from "./Pages/Users";
import Media from "./Pages/Broadcasting/Media";
import AddMedia from "./Pages/Broadcasting/AddMedia";
import Campaign from "./Pages/Broadcasting/Campaign";
import UserDashboard from "./Pages/Reports/UserDashboard";
import UserLog from "./Pages/Reports/UserLog";
import ScreenAvailable from "./Pages/Reports/ScreenAvailable";
import ScreenStatus from "./Pages/Reports/ScreenStatus";
import MessageLog from "./Pages/Reports/MessageLog";
import ScheduledMessageLog from "./Pages/Reports/ScheduledMessageLog";
import ForgotPassword from "./Pages/ForgotPassword";
import AddUpdates from "./Pages/Updates/AddUpdates";
import RecentUpdates from "./Pages/Updates/RecentUpdates";

export default function PublicRoute() {
  return (
    <div className="wrapper" style={{ overflowX: "hidden" }}>
      <Routes>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/two-step-verification" element={<TwoStep />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />

          {/* Users */}
          <Route path="/add-user" element={<Add />} />
          <Route path="/edit-user/:userID" element={<Add />} />
          <Route path="/all-users" element={<Users />} />

          {/* Locations */}
          <Route path="/location/countries" element={<Country />} />
          <Route path="/location/states" element={<State />} />
          <Route path="/location/cities" element={<City />} />
          <Route path="/location/buildings" element={<Building />} />
          <Route path="/location/floors" element={<Floor />} />
          <Route path="/location/screens" element={<Screen />} />

          {/* Broadcast */}
          <Route path="/broadcasting/media" element={<Media />} />
          <Route path="/broadcasting/media/add" element={<AddMedia />} />
          <Route path="/broadcasting/media/:type/:media" element={<Screen />} />
          <Route path="/broadcasting/campaigns" element={<Campaign />} />

          {/* Reports */}
          <Route path="/reports/user-dashboard" element={<UserDashboard />} />
          <Route path="/reports/user-log" element={<UserLog />} />
          <Route
            path="/reports/screen-available"
            element={<ScreenAvailable />}
          />
          <Route path="/reports/screen-status" element={<ScreenStatus />} />
          <Route path="/reports/message-log" element={<MessageLog />} />
          <Route
            path="/reports/scheduled-message"
            element={<ScheduledMessageLog />}
          />

          <Route path="/add-updates" element={<AddUpdates />} />
          <Route path="/updates" element={<RecentUpdates />} />
        </Route>
        <Route path="/*" element={<div>Not Found</div>} />
      </Routes>
    </div>
  );
}
